import CryptoJS from "crypto-js";

const secretKey = process.env.REACT_APP_ENCRYPT_SECRET_KEY || "secretKey"; //process.env.REACT_APP_ENCRYPT_SECRET_KEY || "secretKey"
const secretIv = process.env.REACT_APP_ENCRYPT_SECRET_IV || "secretIV"; //process.env.REACT_APP_ENCRYPT_SECRET_IV || "secretIV"

const decriptPhrase =
  process.env.REACT_APP_DECRYPT_PASSPHRASE || "decryptPhrase"; //process.env.REACT_APP_DECRYPT_PHRASE || "decryptPhrase"
const encryptPhrase =
  process.env.REACT_APP_ENCRYPT_PASSPHRASE || "encryptPhrase"; //process.env.REACT_APP_ENCRYPT_PHRASE || "encryptPhrase"

export const encryptState = (state: any) => {
  return CryptoJS.AES.encrypt(JSON.stringify(state), secretKey).toString();
};

export const decryptState = (encryptedState: string | null) => {
  if (!encryptedState) return null; // Evita procesar valores nulos o indefinidos

  try {
    const bytes = CryptoJS.AES.decrypt(encryptedState, secretKey);
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedText) {
      console.warn("El contenido desencriptado está vacío o es inválido.");
      return null;
    }

    return JSON.parse(decryptedText);
  } catch (error) {
    console.error("Error al desencriptar el estado:", error);
    return null; // Retornar `null` en caso de error para evitar crasheos
  }
};

export const decryptDataResponse = (data: any) => {
  try {
    if (data.token) return data;

    const encrypted = data.data;
    // console.log("Texto encriptado:", encrypted);
    // const bytes = CryptoJS.AES.decrypt(encrypted, decriptPhrase);
    const decryptedText = CryptoJS.AES.decrypt(
      encrypted,
      decriptPhrase
    ).toString(CryptoJS.enc.Utf8);

    // console.log("Texto desencriptado:", decryptedText);
    // Verifica si el texto desencriptado es válido
    if (!decryptedText) {
      console.warn("⚠️ El texto desencriptado está vacío o inválido.");
      return null;
    }

    // console.log("Texto desencriptado:", typeof JSON.parse(decryptedText));
    return JSON.parse(JSON.stringify(decryptedText));
  } catch (error) {
    console.error("Error al desencriptar los datos:", error);
    return null;
  }
};

export const encryptDataRequest = (data: any) => {
  const stringData = JSON.stringify(data); // Serializa el objeto
  return CryptoJS.AES.encrypt(stringData, encryptPhrase).toString();
};
